import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Form,
  Table
} from "reactstrap";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import Spinners from "../../../components/Common/Spinner";
import * as Yup from "yup";
import { useFormik } from "formik";
import { putCostCenterEmployees, getCostCentersAdminNotEmployees } from "../../../helpers/api_rombo_helper";
import { map } from "lodash";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";
import StyledPagination from "../../../components/Common/StyledPagination";

const AddedEmployeesModal = ({ reloadCostCenterEmployees, setReloadCostCenterEmployees, costCenterEmployees, isOpen, toggle, setShowAlertSuccess, setAddedEmployeesModal, selectCostCenter, setTextHeader, setTextBody, token }) => {

  const [employees, setEmployees] = useState({});
  const [checkAddEmployees, setCheckAddEmployees] = useState([]);
  const [opts, setOpts] = useState({});
  const [findEmployees, setFindEmployees] = useState([]);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const dispatch = useDispatch();

  const addedEmployees = () => {
    let body = {
      employees: checkAddEmployees
    }
    putCostCenterEmployees(token, selectCostCenter.id, body)
      .then((response) => {
        setShowAlertSuccess(true)
        setAddedEmployeesModal(false)
        setReloadCostCenterEmployees(!reloadCostCenterEmployees)
        setTextHeader(i18n.t("AddedEmployees"))
        setTextBody(i18n.t("SuccessAddEmployees", { name: selectCostCenter.name, number: checkAddEmployees.length }))
      })
      .catch((error) => {
        console.error("Error - putCostCenterEmployees - ", error)
        setErrorAlertMessage(error.response.data.detail ||= error.message);
        if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
        setErrorAlert(true);
      })
  }

  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    initCheckBox()
    onCheckSelectEmployee()
  }, [findEmployees]);

  useEffect(() => {
    onGetCostCentersAdminNotEmployees()
  }, [dispatch]);

  useEffect(() => {
    if(document.getElementById("checkAll")){
      document.getElementById("checkAll").checked ? setCheckAddEmployees([]) : null
      document.getElementById("checkAll").checked = false
    }
  }, [isLoading]);

  const onCheckSelectEmployee = () => {
    checkAddEmployees.map((item) => document.getElementById(`check-${item.id}`) ? document.getElementById(`check-${item.id}`).checked = true : null)
  }

  const autoformik = useFormik({
    initialValues: {
      name: "",
      email: "",
      services: ""
    },
    validationSchema: Yup.object({
      name: Yup.string(),
      email: Yup.string(),
      services: Yup.number()
    })
  });

  const initCheckBox = () => {
    var checkboxes = document.getElementsByClassName("checksEmployees")
    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false
    }
  }

  const checkExistEmployee = (args) => {
    return costCenterEmployees.items.filter(function(opt) { return opt.id == args.id })[0]
  }

  const onGetCostCentersAdminNotEmployees = (newOpts = {page: 1, size: 10, cost_center_id: selectCostCenter.id}) => {
    getCostCentersAdminNotEmployees(token, newOpts)
      .then((response) => {
        setOpts(newOpts)
        setLoading(false)
        setEmployees(response)
        setFindEmployees(response.items)
      })
      .catch((error) => {
        console.error("Error - getCostCentersAdminNotEmployees - ", error)
      })
  }

  const onClickAddEmployees = (args, type, e) => {    
    let addEmployees = checkAddEmployees
    if(type == "one"){
      if(e.target.checked){
        addEmployees.push({ id: args.id })
        setCheckAddEmployees(addEmployees)
      }
      else{
        let checkDeleteEmployee = addEmployees.filter(function(opt) { 
          return opt.id === args.id
        });
        if(checkDeleteEmployee.shift()){
          addEmployees.splice(addEmployees.indexOf(checkDeleteEmployee.shift()), 1);
        }
      }
    }else{
      let arrAddEmployees = []
      setCheckAddEmployees(arrAddEmployees);
      if(e.target.checked){
        findEmployees.map((item) => {
          checkExistEmployee(item) ? null : arrAddEmployees.push({ id: item.id })
          document.getElementById(`check-${item.id}`) ? document.getElementById(`check-${item.id}`).checked = true : null
        });
        setCheckAddEmployees([...arrAddEmployees])
      }
      else{
        findEmployees.map((item) => {
          document.getElementById(`check-${item.id}`) ? document.getElementById(`check-${item.id}`).checked = false : null
        })
      }
    }
  }

  const searchFilters = (value, type) => {
    var newOpts = {
      name: type == "name" ? value : autoformik.values.name,
      cost_center_id: selectCostCenter.id,
      size: 10
    }
    onGetCostCentersAdminNotEmployees(newOpts)
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"xl"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("AddEmployees")}</p>
        <div className="request-separator"></div>
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            text={errorAlertMessage}
          />
          <Row className="pb-2">
            <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
              <Col xxl={4} md={4} xs={12}>
                <div className="col-sm-auto">                        
                  <Input
                    type="text"
                    name="name"
                    className="form-control"
                    id="nameInput"
                    placeholder={i18n.t("SearchName")}
                    value={autoformik.values.name}
                    onBlur={(e) => autoformik.handleBlur(e)}
                    onChange={(e) => {
                      autoformik.handleChange(e);
                      searchFilters(e.target.value, "name");
                    }}
                    invalid={
                      autoformik.touched.name && autoformik.errors.name ? true : false
                    }
                  />
                  {
                    autoformik.errors.name && autoformik.touched.name ? (
                      <FormFeedback type="invalid">
                        {autoformik.errors.name}
                      </FormFeedback>
                    ) : null
                  }
                </div>
              </Col>
              {/* <Col xxl={2} md={2} xs={12}>
                <div className="col-sm-auto">
                  <Input type="text" name="email" className="form-control" id="emailInput" placeholder={i18n.t("Email")}
                    value={autoformik.values.email}
                    // onBlur={(e) => autoformik.handleBlur(e)}
                    // onChange={(e) => {
                    //   autoformik.handleChange(e);
                    //   searchFilters(e.target.value, "email");
                    // }}
                    invalid={
                      autoformik.touched.email && autoformik.errors.email ? true : false
                    } />
                  {
                    autoformik.errors.email && autoformik.touched.email ? (
                      <FormFeedback type="invalid">{autoformik.errors.email}</FormFeedback>
                    ) : null
                  }
                </div>
              </Col>
              <Col xxl={2} md={2} xs={12}>
                <div className="col-sm-auto">
                  <Input type="text" name="services" className="form-control" id="servicesInput" placeholder={i18n.t("Services")}
                    value={autoformik.values.services}
                    // onBlur={(e) => autoformik.handleBlur(e)}
                    // onChange={(e) => {
                    //   autoformik.handleChange(e);
                    //   searchFilters(e.target.value, "services");
                    // }}
                    invalid={
                      autoformik.touched.services && autoformik.errors.services ? true : false
                    } />
                  {
                    autoformik.errors.services && autoformik.touched.services ? (
                      <FormFeedback type="invalid">{autoformik.errors.services}</FormFeedback>
                    ) : null
                  }
                </div>
              </Col> */}
            </Form>
          </Row>
          <Row>
            <Col>
              <div className="table-responsive pt-3">
                <Table className="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th className="table-header2">
                        <Input
                          type="checkbox"
                          id="checkAll"
                          name="checkAll"
                          onClick={(e) => onClickAddEmployees(null, "all", e)}
                        />
                      </th>
                      <th className="table-header2">{i18n.t("Name")}</th>
                      <th className="table-header2">{i18n.t("Email")}</th>
                      <th className="table-header2">{i18n.t("Status")}</th>
                    </tr>
                  </thead>
                  {
                    isLoading ? null :
                      <tbody>
                        {map(findEmployees, (employee, key) => (
                          <tr key={key}>
                            <td scope="row">
                              {(costCenterEmployees?.items || [])
                                .filter((f) => f.id == employee.id).length == 0 ? (
                                  <Input
                                    type="checkbox"
                                    id={`check-${employee.id}`}
                                    className="checksEmployees"
                                    name={`check-${employee.id}`}
                                    onClick={(e) => onClickAddEmployees(employee, "one", e)}
                                  />
                                ) : null
                              }
                            </td>
                            <td>{employee.name}</td>
                            <td>{employee.email}</td>
                            <td>
                              <div
                                className={`employee-status ${
                                  employee.status === "ACTIVE"
                                    ? "employee-status-active"
                                    : "employee-status-inactive"
                                }`}
                              >
                                {i18n.t(employee.status)}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                  }
                </Table>
                {isLoading ? (
                  <Spinners setLoading={setLoading} /> 
                ) : ( 
                  <StyledPagination
                    setLoading={setLoading}
                    viewPaginations={5}
                    pages={employees.pages}
                    token={token}
                    listTable={setFindEmployees}
                    id={null}
                    methodCustom={getCostCentersAdminNotEmployees}
                    opts={opts}
                    page={employees.page}
                    total={employees.total}
                    size={employees.size}
                    paginationDiv="col-lg-12"
                    paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                  />
                )}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            onClick={addedEmployees}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

AddedEmployeesModal.propTypes = {
  setShowAlertSuccess: PropTypes.func,
  setAddedEmployeesModal: PropTypes.func,
  toggle: PropTypes.func,
  selectCostCenter: PropTypes.object,
  isOpen: PropTypes.bool,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  setReloadCostCenterEmployees: PropTypes.func,
  reloadCostCenterEmployees: PropTypes.bool
}

export default AddedEmployeesModal;
